export const formatValue = (value: number): string | number => (value === -1 ? '-' : value)
